/* eslint-disable global-require */

import angular from 'angular';
import './notifications-wrap.styles.scss';

export default angular.module('directives.notificationsWrap', [])
  .directive('notificationsWrap', () => {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      templateUrl: require('./notifications-wrap.template.html'),
    };
  })
  .name;
